import { BKJSideModal } from 'components/BKJSideModal';
import { useTranslation } from 'hooks/useTranslation';
import { FC, useMemo } from 'react';
import { usePositionsAllocationModalUIContext } from 'pages/SettingsPage/PositionsSettingsPage/B2BPositionsSettingsPage/modals/PositionsByLocation/PositionsAllocationModal.ui.context';
import { PositionsAllocationComponentMap } from 'pages/SettingsPage/PositionsSettingsPage/B2BPositionsSettingsPage/modals/PositionsByLocation/PositionsAllocationModal.constants';
import { positionsAllocationModalRoutingService } from 'pages/SettingsPage/PositionsSettingsPage/B2BPositionsSettingsPage/modals/PositionsByLocation/PositionsAllocationModalRouting.constants';

export const PositionsAllocationModalComponent: FC = () => {
  const { isOpen, positionsAllocationActiveModalView } = usePositionsAllocationModalUIContext();
  const { t } = useTranslation();

  const Component = useMemo(
    () => PositionsAllocationComponentMap[positionsAllocationActiveModalView],
    [positionsAllocationActiveModalView],
  );

  const modalHeader = {
    ApplyPositionView: t('location_settings:LOCATIONS_ALLOCATION'),
  };
  return (
    <BKJSideModal
      isOpen={isOpen}
      onClose={positionsAllocationModalRoutingService.close}
      headerComponent={modalHeader[positionsAllocationActiveModalView]}
    >
      {isOpen && <Component />}
    </BKJSideModal>
  );
};
